import { Map, fromJS } from 'immutable';

export function request(state, action) {
    action.postCode = action.postCode.toUpperCase();

    return state
        .set('_last', action.postCode)
        .set(
            action.postCode,
            (state.get(action.postCode) || Map())
                .set('state', 'IN_PROGRESS')
                .set('errors', void 0)
        );
}

export function error(state, action) {
    action.postCode = action.postCode.toUpperCase();

    return state.set(
        action.postCode,
        (state.get(action.postCode) || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );
}

export function finish(state, action) {
    action.postCode = action.postCode.toUpperCase();

    return state
        .set(
            action.postCode,
            (state.get(action.postCode) || Map())
                .set('results', fromJS(action.results))
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}

export function clear() {
    return Map();
}
